import { IDate } from '@/coreDomainsModule/date';
import { IArrival, OrderStatus } from '@/coreDomainsModule/entities/arrival';
import { IBusiness } from '@/coreDomainsModule/entities/businessBase';
import { DateService } from '@/coreDomainsModule/services/dateService';
import { CalendarOrder } from '../entities/CalendarOrder';

/**
 * カレンダー上の発注に関するサービス
 */
export class CalendarOrderService {
  /**
   * 特定の日付の発注情報を取得する
   * @param orders - 発注情報
   * @param date - 日付
   */
  public static getOrdersByDate = (orders: CalendarOrder[], date: IDate): CalendarOrder[] => {
    return orders.filter((order) => (order.crossDate === undefined ? false : DateService.equalYearMonthDayInfo(order.crossDate, date)));
  };

  /**
   * 与えられた発注時情報が、入荷予定日（IArrival.crossDate）を変更可能かどうかを発注ステータスから判定してBool値を返す（＝カレンダー内でドラッグ可能かどうか）
   * @param order - 発注情報
   */
  public static isChangeableCrossDate = (order: CalendarOrder): boolean => {
    switch (order.status) {
      // 数量・納期回答待ち、納期回答待ち（数量確定済み）、分納、承認依頼の場合は変更可能
      case OrderStatus.ApprovedAwaitingDeliveryDate:
      case OrderStatus.QuantityConfirmed:
      case OrderStatus.PartialDelivery:
      case OrderStatus.DeliveryDelayed:
      case OrderStatus.ApprovalRequested:
        return true;
      default:
        return false;
    }
  };

  /**
   * 与えられた発注時情報が、数量を変更可能かどうかを発注ステータスから判定してBool値を返す（＝カレンダー内で数量変更可能かどうか）
   * @param order - 発注情報
   */
  public static isChangeableQuantity = (order: CalendarOrder): boolean => {
    switch (order.status) {
      // 承認済み、承認依頼の場合は数量変更可能
      case OrderStatus.ApprovedAwaitingDeliveryDate:
      case OrderStatus.ApprovalRequested:
        return true;
      default:
        return false;
    }
  };

  /**
   * 納期を確定した際の発注ステータスの遷移先を返す
   * @param orderStatus - 現在の発注ステータス
   */
  public static getProgressOrderStatusWhenFixDeliveryDate = (orderStatus: OrderStatus): OrderStatus => {
    switch (orderStatus) {
      // 承認済みからは納期確定（数量確定待ち）に遷移
      case OrderStatus.ApprovedAwaitingDeliveryDate:
        return OrderStatus.DeliveryDateConfirmed;
      case OrderStatus.QuantityConfirmed:
        return OrderStatus.Confirmed;
      default:
        // それ以外のステータスは遷移しない
        return orderStatus;
    }
  };
}
